import { WebEdiDto, WrapperDelFor } from '../../data/models'
import { DefaultConfig } from '../../features/ui-config'

export function getConfigKeyByMessageType(
  messageType?: WebEdiDto['MessageType'] | WrapperDelFor['MessageType'],
): keyof DefaultConfig {
  // Get the config key
  switch (messageType) {
    case 'ORDRSP':
      return 'orderResponse'
    case 'DESADV':
      return 'despatchAdvice'
    case 'INVOICE':
      return 'invoice'
    case 'DELPLA':
    case 'DELSCH':
      return 'deliveryForecast'
    case 'DELDESADV':
    default:
      return 'deliveryForecastDespatchAdvice'
  }
}
